import React, { Fragment } from 'react';

import { FormFieldType } from '../../dynamic-form/types/inputTypes';
import { AutocompleteFormField } from '../AutocompleteFormField';
import CurrencyFormField from '../CurrencyFormField';
import DatePickerFormField from '../DatePickerFormField';
import NumberInputFormField from '../NumberInputFormField';
import PercentageFormField from '../PercentageFormField';
import SelectFormField from '../SelectFormField';
import TextInputFormField from '../TextInputFormField';
import { IRepeaterFieldInputProps } from '.';

const RepeaterBoxInputField: React.FC<IRepeaterFieldInputProps> = ({
  value,
  rowIndex,
  error,
  autocompleteKey,
  touched,
  disabled,
  onFieldChange,
  onFieldBlur,
  onAutocompleteSearch,
  loading,
  input
}) => {
  let title = input.title;
  const length = input?.dynamicTitle?.length;
  if (length > 0 && rowIndex < length) {
    title = input.dynamicTitle[rowIndex];
  }
  switch (input.type) {
    case FormFieldType.percentage:
      return (
        <PercentageFormField
          key={`${input.name}-${rowIndex}`}
          name={input.name}
          title={title}
          placeholder={input.placeholder}
          value={value}
          error={touched ? error : ''}
          loader={loading}
          disabled={input.disabled || disabled}
          material={input.material}
          onChange={(event) => {
            const value = event.target.value;
            onFieldChange(input.name, value, rowIndex);
          }}
          onBlur={() => {
            onFieldBlur(input.name, rowIndex);
          }}
        />
      );
    case FormFieldType.text:
      return (
        <TextInputFormField
          key={`${input.name}-${rowIndex}`}
          name={input.name}
          title={title}
          placeholder={input.placeholder}
          value={value}
          disabled={input.disabled || disabled}
          onChange={(event) => {
            const value = event.target.value;
            onFieldChange(input.name, value, rowIndex);
          }}
          error={touched ? error : ''}
          material={input.material}
          onBlur={() => {
            onFieldBlur(input.name, rowIndex);
          }}
        />
      );
    case FormFieldType.date:
      return (
        <DatePickerFormField
          key={`${input.name}-${rowIndex}`}
          name={input.name}
          title={title}
          placeholder={input.placeholder}
          value={value}
          disabled={input.disabled || disabled}
          minDate={input.minDate}
          maxDate={input.maxDate}
          canClearDate={input.canClearDate}
          onDateChange={(v) => {
            onFieldChange(input.name, v, rowIndex);
          }}
          error={touched ? error : ''}
          material={input.material}
          onBlur={() => {
            onFieldBlur(input.name, rowIndex);
          }}
        />
      );
    case FormFieldType.select:
      return (
        <SelectFormField
          key={`${input.name}-${rowIndex}`}
          name={input.name}
          title={title}
          placeholder={input.placeholder}
          value={value}
          selectOptions={input.selectOptions}
          canClearValue={input.canClearValue}
          freeSolo={input.freeSolo}
          loader={loading}
          disabled={input.disabled || disabled}
          onChange={(v) => {
            onFieldChange(input.name, v, rowIndex);
          }}
          error={touched ? error : ''}
          material={input.material}
          onBlur={() => {
            onFieldBlur(input.name, rowIndex);
          }}
        />
      );

    case FormFieldType.currency:
      return (
        <CurrencyFormField
          key={`${input.name}-${rowIndex}`}
          name={input.name}
          title={title}
          placeholder={input.placeholder}
          value={value}
          error={touched ? error : ''}
          onBlur={() => onFieldBlur(input.name, rowIndex)}
          onChange={(event) => {
            const newValue = event.target.value;
            onFieldChange(input.name, newValue, rowIndex);
          }}
          disabled={input.disabled || disabled}
          currencySymbol={input.currencySymbol}
          material={input.material}
        />
      );

    case FormFieldType.number:
      return (
        <NumberInputFormField
          key={`${input.name}-${rowIndex}`}
          name={input.name}
          title={title}
          placeholder={input.placeholder}
          value={value}
          minValue={input.minValue}
          maxValue={input.maxValue}
          allowNegativeValues={input.allowNegativeValues}
          allowExponential={input.allowExponential}
          formatOnBlur={input.formatOnBlur}
          maxDecimalPrecision={input.maxDecimalPrecision}
          disabled={input.disabled || disabled}
          error={touched ? error : ''}
          material={input.material}
          onChange={(event) => {
            const value = event.target.value;
            onFieldChange(input.name, value, rowIndex);
          }}
          onBlur={() => {
            onFieldBlur(input.name, rowIndex);
          }}
        />
      );

    case FormFieldType.autocomplete:
      return (
        <AutocompleteFormField
          key={input.name}
          name={input.name}
          title={title}
          placeholder={input.placeholder}
          value={value}
          error={touched ? error : ''}
          disabled={input.disabled || disabled}
          initialOptions={input.initialOptions}
          onChange={(value) => {
            onFieldChange(input.name, value, rowIndex);
          }}
          onBlur={() => {
            onFieldBlur(input.name, rowIndex);
          }}
          fetchOptions={async (query: string) => {
            if (onAutocompleteSearch) {
              const result = await onAutocompleteSearch(input.name, query, {
                pageNumber: 1,
                pageSize: 10
              });

              return result.options;
            }

            return {};
          }}
          excludeIds={input.excludeIds}
        />
      );
    default:
      return (
        <Fragment key={input.name}>
          ERROR: {input.type} not implemented
        </Fragment>
      );
  }
};

export default RepeaterBoxInputField;
